import jwtDefaultConfig from './jwtDefaultConfig'

export default class JwtService {
  axiosIns = null;
  appUrl = null;

  jwtConfig = { ...jwtDefaultConfig };
  isAlreadyFetchingAccessToken = false;
  subscribers = [];

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig };
    this.appUrl = process.env.VUE_APP_URL;

    this.axiosIns.interceptors.request.use(
      config => {
        const accessToken = this.getToken();
        if (accessToken) {
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`;
        }
        return config;
      },
      error => Promise.reject(error)
    );

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      response => response,
      error => {
        const { config, response } = error;
        const originalRequest = config;

        if (response && response.status === 401) {
          if (!this.isAlreadyFetchingAccessToken) {
            this.isAlreadyFetchingAccessToken = true;
            this.refreshToken().then(r => {
              this.isAlreadyFetchingAccessToken = false;

              // Update accessToken in localStorage
              this.setToken(r.data.token.accessToken);
              this.setRefreshToken(r.data.token.refreshToken);

              this.onAccessTokenFetched(r.data.accessToken);
            })
            .catch(() => {
              localStorage.removeItem('userData');
            });
          }
          const retryOriginalRequest = new Promise(resolve => {
            this.addSubscriber(accessToken => {
              originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`;
              resolve(this.axiosIns(originalRequest));
            })
          })
          return retryOriginalRequest;
        }
        return Promise.reject(error);
      },
    )
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken));
  }

  addSubscriber(callback) {
    this.subscribers.push(callback);
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName);
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName);
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value);
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(...args) {
    return this.axiosIns.post(this.appUrl+this.jwtConfig.loginEndpoint, ...args);
  }

  refreshToken() {
    return this.axiosIns.post(this.appUrl+this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken(),
    });
  }

  logout() {
    localStorage.removeItem('userData');
    return this.axiosIns.post(this.appUrl+this.jwtConfig.logoutEndpoint);
  }

  async request(myHost, rq='') {
    return this.axiosIns.post(this.appUrl+myHost, rq);
  }

  get(myHost) {
    return this.axiosIns.get(this.appUrl+myHost);
  }

  async requestWithFile(myHost, rq='') {
    
    return this.axiosIns.post(this.appUrl+myHost, rq, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            });
  }
}
